/* unplugin-vue-components disabled */
import {DropdownCalendar} from 'components/filters'
import {API_TASKS} from 'consts/api'
import TasksRunner from 'components/tasks-runner'

export default {
  components: {
    DropdownCalendar,
    TasksRunner
  },
  data() {
    return {
      filter_dates: [],
      excluded_email_domains: [],
      excluded_user_emails: [],
      selected_metrics: [],
      metric_items: [
        {label: 'Active Users', value: 'active_users'},
        {label: 'Chat Queries', value: 'chat_queries'},
        {label: 'Onboarding Queries', value: 'onboarding_queries'},
        {label: 'Reports', value: 'reports'},
      ],
      filelist: []
    }
  },
  computed: {
    can_run(){
      return !!(this.filter_dates.length && this.selected_metrics.length)
    },
    min_date(){
      const min_date = new Date()
      min_date.setDate(min_date.getDate() - 90)
      return min_date
    },
    date(){
      if (!this.filter_dates.length) return
      const start = this.filter_dates && this.filter_dates[0] && $utils.format.date(this.filter_dates[0])
      const end = this.filter_dates && this.filter_dates[1] && `${$utils.format.date(this.filter_dates[1])}`
      return `${start} - ${end}`
    },
  },
  methods: {
    handleExceed(files) {
      this.$refs.csv_file.clearFiles()
      const [file] = files
      this.$refs.csv_file.handleStart(file)
    },
    onFileChange(file) {
      if (file.name.split('.').length > 2) {
        $utils.toasts.error('The file extension contains two dots.')
        this.$refs.csv_file.clearFiles()
      }
    },
    async runUsageReports(tasks) {
      if (!this.filter_dates.length) {
        $utils.toasts.error('Please select date range')
        return
      }
      if (!this.selected_metrics.length) {
        $utils.toasts.error('Please select at least one metric')
        return
      }

      const [min_date, max_date] = $utils.format.normalizeDateRangeWithOffset(this.filter_dates)

      const payload = {
        min_date,
        max_date,
        excluded_email_domains: this.excluded_email_domains,
        excluded_user_emails: this.excluded_user_emails,
        selected_metrics: this.selected_metrics,
      }
      const options = {
        force_form_data: true
      }

      const formData = new FormData()
      formData.append('payload', JSON.stringify(payload))
      if (this.filelist.length > 0) {
        formData.append('file', this.filelist[0].raw)
      }

      return await tasks.start(`${API_TASKS}/tenant-usage-reports`, formData, options)
    }
  }
}
